"use strict";

var canvisIcons = function () {
    var plusIcon = require("./PlusIcon");
    var leafIcon = require("./LeafIcon");
    var minusIcon = require("./MinusIcon");

    var minusUrl = minusIcon();
    var leafUrl = leafIcon();
    var plusUrl = plusIcon();
};

module.exports = canvisIcons;
